import { nonEmptyStringSchemaValidator } from 'schemas/ajv-validators';
import { validateWithAjv } from './validate-with-ajv';

export const validateString = (value: unknown) => validateWithAjv(nonEmptyStringSchemaValidator, value);
